import React from 'react';
import { useTranslation } from 'react-i18next';

/** Keep wide clinical/financial tables intact inside a keyboard-scrollable region. */
export function ResponsiveTable({ children }: { children: React.ReactNode }) {
  const { t } = useTranslation();
  return <div className="responsive-table-scroll" role="region" aria-label={t('responsive.table')} tabIndex={0}>{children}</div>;
}
